<template>
    <v-container
        fluid
        class="pa-4 mt-auto contact"
        :style="{
            backgroundImage: backgroundRender,
        }"
    >
        <v-card class="pa-4 mx-auto" max-width="800px" width="80%">
            <h6>Angaben gemäß § 5 TMG:<br /><br /></h6>
            <p>
                Klaukien, Oechsle GbR<br />
                Conventstraße 8-10 | Haus A<br />

                22089 Hamburg<br />
            </p>
            <br />
            <h6>Kontakt:</h6>

            <p>Telefon: +49 (0) 40 876 037 84</p>
            <p>E-Mail: info@bandrecording-hamburg.de</p>
            <h6>Angaben zur Berufshaftpflichtversicherung:</h6>
            <p>
                Name und Sitz der Gesellschaft:<br /><br />ARAG
                Versicherungen-AG<br />
                ARAG Platz 1 <br />
                40472 Düsseldorf
            </p>
            <p>Geltungsraum der Versicherung: Deutschland</p>
            <p></p>
            <br />

            <h6>Haftungsausschluss:</h6>
            <br />
            <p><strong>Haftung für Inhalte</strong></p>
            <p>
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
                Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
                können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter
                sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8
                bis 10 TMG sind wir als Diensteanbieter jedoch nicht
                verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die
                auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur
                Entfernung oder Sperrung der Nutzung von Informationen nach den
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine
                diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
                Kenntnis einer konkreten Rechtsverletzung möglich. Bei
                Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
                diese Inhalte umgehend entfernen.
            </p>

            <p><br /><strong>Haftung für Links</strong></p>
            <p>
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
                wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                Verlinkung nicht erkennbar. Eine permanente inhaltliche
                Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
                Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                umgehend entfernen.
            </p>

            <br />
            <p><strong>Urheberrecht</strong></p>
            <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten,
                nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
                dieser Seite nicht vom Betreiber erstellt wurden, werden die
                Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
                Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
                Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
                entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
                werden wir derartige Inhalte umgehend entfernen.
            </p>

            <br />
            <p><strong>Datenschutz</strong></p>
            <p>
                Die Nutzung unserer Webseite ist in der Regel ohne Angabe
                personenbezogener Daten möglich. Soweit auf unseren Seiten
                personenbezogene Daten (beispielsweise Name, Anschrift oder
                eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich,
                stets auf freiwilliger Basis. Diese Daten werden ohne Ihre
                ausdrückliche Zustimmung nicht an Dritte weitergegeben.
            </p>

            <br />
            <p>
                Wir weisen darauf hin, dass die Datenübertragung im Internet
                (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken
                aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff
                durch Dritte ist nicht möglich.
            </p>
            <p>
                Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
                Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich
                angeforderter Werbung und Informationsmaterialien wird hiermit
                ausdrücklich widersprochen. Die Betreiber der Seiten behalten
                sich ausdrücklich rechtliche Schritte im Falle der unverlangten
                Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.
            </p>
            <p></p
        ></v-card>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        backgroundColor1: '',
        backgroundColor2: '',
        backgroundRender: '',
        colorArray1: [
            'rgba(255, 173, 173, .75)',
            'rgba(160, 196, 255, .75)',
            'rgba(255, 214, 165, .75)',
            'rgba(202, 255, 191, .75)',
            'rgba(105, 48, 195, .75)',
        ],
        colorArray2: [
            'rgba(253, 255, 182, .8)',
            'rgba(189, 178, 255, .8)',
            'rgba(155, 246, 255, .8)',
            'rgba(160, 196, 255, .8)',
            'rgba(255, 183, 3, .8)',
        ],
    }),

    created() {
        this.backgroundColor1 = this.colorArray1[Math.floor(Math.random() * 5)];
        this.backgroundColor2 = this.colorArray2[Math.floor(Math.random() * 5)];
        this.backgroundRender =
            'linear-gradient(' +
            this.backgroundColor1 +
            ',' +
            this.backgroundColor2 +
            '), url(' +
            'https://bandrecording-hamburg.de/assets/backgrounds/' +
            Math.floor(Math.random() * 7 + 1) +
            '.jpg)';
    },
};
</script>

<!-- Design rules for the template. -->
<style scoped>
.contact {
    margin: 0;
    background-repeat: no-repeat;
    background-size: cover;
    background-position-y: top;
    background-position-x: center;
    width: 100%;
    min-height: 100vh;
}
</style>
